import { useEffect } from "react";
import { salesActions } from "redux/Ldb/actions";
import { useAppDispatch, useAppSelector } from "../storeHooks";

const useGetSalesSettings = () => {
    const dispatch = useAppDispatch();
    const { fetchingSalesSettings, fetchSalesSettingsSuccess, fetchSalesSettingsFailure } =
        useAppSelector((state) => state.sales);

    const refetch = () => {
        dispatch(salesActions.getSalesSettings());
    };

    useEffect(() => {
        refetch();
    }, []);

    return {
        fetchingSalesSettings,
        fetchSalesSettingsSuccess,
        refetch,
    };
};

export default useGetSalesSettings;
